import { GrowthBook, InitOptions, Context } from '@growthbook/growthbook-react';
import { growthBookCustomFlags, IGrowthBookFeatures } from './growthbook.interfaces';
import { handleGrowthBookOverrides } from './handleGrowthBookOverrides';
import { isValidExternalKey } from '../config';

const growthBookUrl = window.growthBookUrl?.trim();

export const isValidGrowthBookUrl = isValidExternalKey({ growthBookUrl });

export const initGrowthBook = () => {
  const growthbookOptions: Context = {};

  const initOptions: InitOptions = {
    timeout: 2000,
  };

  if (isValidGrowthBookUrl) {
    const url = new URL(growthBookUrl);
    const apiHost = url.origin;
    const clientKey = url.pathname.slice(url.pathname.lastIndexOf('/') + 1);
    growthbookOptions.apiHost = apiHost;
    growthbookOptions.clientKey = clientKey;
  } else if (process.env.NODE_ENV !== 'production') {
    initOptions.payload = { features: growthBookCustomFlags };
  } else {
    initOptions.payload = {};
  }
  const gb = new GrowthBook<IGrowthBookFeatures>(growthbookOptions);

  const ready = gb
    .init(initOptions)
    .catch(() => {})
    .then(() => {
      /**
       * Must run after init settles: init calls setPayload with the CDN payload and would
       * otherwise clobber the User-Agent overrides.
       */
      if (isValidGrowthBookUrl && window.allowFeatureFlagsHeaderOverride) {
        handleGrowthBookOverrides(gb);
      }
    })
    .catch(() => {});

  return { gb, ready };
};

const { gb: growthBook, ready } = initGrowthBook();

export const gb = growthBook;

/**
 * Resolves once GrowthBook has a payload and any User-Agent flag overrides have been
 * applied. Await this before the first synchronous gb.isOn read in an async flow —
 * gb.init has a 2000 ms timeout, so early readers could otherwise see a flag as false
 * purely because nothing had loaded yet. Never rejects: a GrowthBook failure must leave
 * every disable flag reading false, i.e. nothing disabled.
 */
export const gbReady: Promise<void> = ready;
